import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStateService {
  private _isAutoLogout = signal<boolean>(false);
  
  get isAutoLogout(): boolean {
    return this._isAutoLogout();
  }

  setAutoLogout(value: boolean): void {
    this._isAutoLogout.set(value);
  }

  reset(): void {
    this._isAutoLogout.set(false);
  }
}
